import React from 'react';
import './AdminFeatureSelector.css';

export type AdminFeature = 'deals' | 'store-hours' | 'menu-audit' | 'home-collections' | 'popup-alerts';

interface AdminFeatureSelectorProps {
  selectedFeature: AdminFeature;
  onSelectFeature: (feature: AdminFeature) => void;
}

const FEATURES: { id: AdminFeature; label: string }[] = [
  { id: 'deals', label: 'DEALS' },
  { id: 'store-hours', label: 'STORE HOURS' },
  { id: 'menu-audit', label: 'MENU AUDIT' },
  { id: 'home-collections', label: 'HOME COLLECTIONS' },
  { id: 'popup-alerts', label: 'POPUP ALERTS' }
];

const AdminFeatureSelector: React.FC<AdminFeatureSelectorProps> = ({
  selectedFeature,
  onSelectFeature
}) => {
  return (
    <div className="admin-feature-selector">
      <div className="admin-feature-buttons">
        {FEATURES.map((feature) => (
          <button
            key={feature.id}
            className={`admin-feature-btn ${selectedFeature === feature.id ? 'active' : ''}`}
            onClick={() => onSelectFeature(feature.id)}
          >
            {feature.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default AdminFeatureSelector;
